import { render, staticRenderFns } from "./EnterNewTrade.vue?vue&type=template&id=7631980a&scoped=true&"
import script from "./EnterNewTrade.vue?vue&type=script&lang=js&"
export * from "./EnterNewTrade.vue?vue&type=script&lang=js&"
import style0 from "./EnterNewTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EnterNewTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./EnterNewTrade.vue?vue&type=style&index=2&id=7631980a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631980a",
  null
  
)

export default component.exports